import { generateSearchAccordionOpenSettingKey } from '@/features/search/_utils/local-storage';

const FEATURE_NAME = 'workflow';

export const WORKFLOW_SEARCH_ACCORDION_OPEN_SETTING_KEY =
  generateSearchAccordionOpenSettingKey(FEATURE_NAME);
